Sales Dashboard for user <b>{{staffDetail.staffName}}</b>